<!--
<template>
  <div>
    <flv-player :url="videoUrl" />
  </div>
</template>

<script>
import FlvPlayer from './component/FlvPlayer.vue'

export default {
  components: {
    FlvPlayer
  },
  data() {
    return {
      videoUrl: decodeURIComponent(this.$route.query.videoUrl),
      
    }
  },
  methods: {
  }
}
</script>
-->
<template>
   <div class="video-container">
      <video ref="videoElement" controls autoplay muted style="width: 100%"></video>
   </div>
</template>

<script>
import flvjs from "flv.js";

export default {
   name: "FlvPlayer",
   props: {
      url: {
         type: String,
         required: true,
      },
   },
   data () {
      return {
         flvPlayer: null,

      };
   },
   mounted () {
      this.initPlayer();
   },
   beforeDestroy () {
      this.destroyPlayer();
   },
   methods: {
      initPlayer () {
         if (flvjs.isSupported()) {
            const videoElement = this.$refs.videoElement;
            this.flvPlayer = flvjs.createPlayer({
               type: "flv",
               url: this.url,
               isLive: false, // 设置为直播模式
            });
            this.flvPlayer.attachMediaElement(videoElement);
            this.flvPlayer.load();
            this.flvPlayer.play().catch((e) => {
               console.error("播放错误:", e);
            });
            // 监听错误事件
            this.flvPlayer.on(flvjs.Events.ERROR, (errType, errDetail) => {
               videoElement.pause();
            })
         } else {
            this.$message.error("当前浏览器不支持flv.js");
         }
      },



      destroyPlayer () {
         if (this.flvPlayer) {
            this.flvPlayer.pause();
            this.flvPlayer.unload();
            this.flvPlayer.detachMediaElement();
            this.flvPlayer.destroy();
            this.flvPlayer = null;
         }
      },
   },
   watch: {
      url (newVal) {
         this.destroyPlayer();
         this.initPlayer();
      },
   },
};
</script>
